import React, { FunctionComponent, useState } from 'react'
import styled from 'styled-components'
import SvgDownTriangle from '../generated/svg/down-triangle'
import SvgUpTriangle from '../generated/svg/up-triangle'

const Outer = styled.div`
  width: 100%;
`

const ItemOuter = styled.div`
  & + & {
    margin-top: 2rem;
  }
`

const Label = styled.div``

const Question = styled.div`
  display: flex;
  padding: 1.25rem 3rem;
  background-color: var(--background-color, #9c91bd);
  color: white;
  cursor: pointer;
  font-weight: 700;
`
const QuestionLabel = styled(Label)`
  flex: 0 0 2rem;
  line-height: 2;
`
const QuestionText = styled.div`
  line-height: 2;
  white-space: pre-wrap;
`


const Answer = styled.div`
  display: flex;
  padding: 1.25rem 3rem;
  white-space: pre-wrap;
`
const AnswerLabel = styled(Label)`
  flex: 0 0 3rem;
  line-height: 2;
`
const AnswerText = styled.div`
  line-height: 2;
`
const TriangleContainer = styled.div`
  margin-left: auto;
  align-self: center;
  svg {
    width: 1rem;
    height: auto;
  }
`

type FaqProps = {
  faq: {
    question: string,
    answer: string,
    number: number | string
  }[]
}
export const Fqa: FunctionComponent<FaqProps> = ({faq}) => {
  return <Outer>
    {
      Array.from(faq).map((faq) => {
        return <Item key={faq.number} number={faq.number} q={faq.question} a={faq.answer}></Item>
      })
    }
  </Outer>
}

type ItemProps = {
  number: number | string
  q: string
  a: string
}
const Item: FunctionComponent<ItemProps> = ({number, q, a}) => {
  const [isOpen, setIsOpen] = useState(false)
  return <ItemOuter onClick={() => setIsOpen(isOpen => !isOpen)}>
    <Question>
      <QuestionLabel>Q{number}.</QuestionLabel>
      <QuestionText>{q}</QuestionText>
      <TriangleContainer>
        {
          isOpen ? <SvgUpTriangle /> : <SvgDownTriangle />
        }
      </TriangleContainer>
    </Question>
    {
      isOpen &&
      <Answer>
        <AnswerLabel>A{number}.</AnswerLabel>
        <AnswerText>{a}</AnswerText>
      </Answer>
    }
  </ItemOuter>
}